import menu from '@/services/menu.service';
import { MENU_OPTION_EXCEPTIONS } from '@/stores/defs';
import { includes, filter, isEmpty } from 'lodash';
var state = {
    all: [],
    map: {},
};
var getters = {
    allOptions: function (state) { return state.all; },
    getOption: function (state) { return function (id) {
        return state.map[id];
    }; },
    choicesForOption: function (state) { return function (id) {
        if (isEmpty(state.map)) {
            return [];
        }
        return state.map[id].choices;
    }; },
    allOptional: function (state) {
        return filter(state.all, function (option) {
            return !option.required;
        });
    },
    allRequired: function (state) {
        return filter(state.all, function (option) {
            return option.required;
        });
    },
    allForItem: function (state) { return function (item) {
        if (!item) {
            return false;
        }
        return filter(state.all, function (option) {
            return (includes(item.optionIds, option.id));
        });
    }; },
    optionalForItem: function (state) { return function (item) {
        if (!item) {
            return false;
        }
        return filter(state.all, function (option) {
            if (includes(item.optionIds, option.id)) {
                return !option.required;
            }
            return false;
        });
    }; },
    requiredForItem: function (state) { return function (item) {
        if (!item) {
            return false;
        }
        return filter(state.all, function (option) {
            if (includes(item.optionIds, option.id)) {
                return option.required;
            }
            return false;
        });
    }; },
    filteredChoicesForOption: function (state, getters, rootState, rootGetters) { return function (itemId, option) {
        if (itemId) {
            var exceptionModel_1 = rootGetters[MENU_OPTION_EXCEPTIONS.GET_FOR_ITEM](itemId);
            if (!exceptionModel_1) {
                return option.choices;
            }
            var defaultKey_1 = '1-';
            var exceptionOption_1 = (exceptionModel_1.options) ? exceptionModel_1.options[option.id] : null;
            if (exceptionModel_1 && exceptionOption_1) {
                // filter out choices that are excluded
                return option.choices.filter(function (choice) {
                    var exceptionChoice = (exceptionModel_1.options && exceptionOption_1 && exceptionOption_1.choices) ? exceptionOption_1.choices["" + defaultKey_1 + choice.id] : null;
                    // default says excluded, only show if specifically included 
                    if (!exceptionChoice && exceptionOption_1.defaultChoices[defaultKey_1] &&
                        exceptionOption_1.defaultChoices[defaultKey_1].excluded &&
                        !choice.included) {
                        return false;
                    }
                    else if (!exceptionChoice) {
                        return true;
                    }
                    else if (exceptionChoice.excluded) {
                        // the choice is excluded, don't show
                        return false;
                    }
                    return true;
                });
            }
            else {
                return option.choices;
            }
        }
        else {
            return option.choices;
        }
    }; }
};
var actions = {
    fetchOptions: function (_a) {
        var commit = _a.commit;
        if (state.all.length === 0) {
            return menu.getItemOptions(function (options) {
                commit('setOptions', options);
            });
        }
        return state.all;
    },
    setOptions: function (_a, options) {
        var commit = _a.commit;
        commit('setOptions', options);
    },
};
var mutations = {
    setOptions: function (state, options) {
        state.all = options;
        options.forEach(function (option) {
            state.map[option.id] = option;
        });
    },
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/item.option.store.ts
// module id = null
// module chunks = 